import { useStateValue } from 'state';

const useAccess = () => {
  const [{ dashboard }] = useStateValue();
  return roleName => dashboard.user.roles.includes(roleName);
};
export default useAccess;
